// extracted by mini-css-extract-plugin
export var backupIcon = "_om-1";
export var image = "_om-0";